export class Photo {
    
    blobName: string;
    blobStorId: number;
    fileBase64: Blob;
    takenDate: Date;
    referenceKey: number;
}
